import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
} from 'react-admin';

import { EditToolbar } from "../../common/EditToolbar";
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

const VideoSubjectEdit = () => {
    const { isUpdatable } = useIsPermission("VIDEO_SUBJECT");
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<BannerTitle />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput
                        source="name"
                        fullWidth
                        validate={[required(), validateNotEmpty]}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    )
}

const BannerTitle = () => {
    const record = useRecordContext<any>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.video_subjects.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default VideoSubjectEdit;
